import { useTranslations } from '@vocab/react';
import { Badge } from 'braid-design-system';
import type { FC } from 'react';

import type { ReferenceCheckType } from 'src/App/ActionsPage/graphql/types.generated';

import translations from './.vocab';

type Requested = {
  status: 'requested';
};

type Available = {
  status: 'available';
  referenceCheckType: ReferenceCheckType;
  finishedCount: number;
};

export type ReferenceChecksBadgeProps = Requested | Available;

export const ReferenceChecksBadge: FC<ReferenceChecksBadgeProps> = (props) => {
  const { status } = props;
  const { t } = useTranslations(translations);

  if (status === 'requested') {
    return <Badge tone="caution">{t('Checking references')}</Badge>;
  }

  if (props.referenceCheckType === 'LIMITED') {
    return (
      <Badge tone="positive">
        {t('Limited reference/s available ({count})', {
          count: props.finishedCount,
        })}
      </Badge>
    );
  }

  return (
    <Badge tone="positive">
      {t('Reference/s available ({count})', {
        count: props.finishedCount,
      })}
    </Badge>
  );
};
